import "./home.scss";
import { Heading } from "@sainsburys-tech/luna-typography";
import { Label } from "@sainsburys-tech/luna-form";
import { ProgressIndicator, ProgressSpinner } from "@sainsburys-tech/luna-progress";
import { FilledButton } from "@sainsburys-tech/luna-button";
import { StandardTileProps } from "../../Interfaces/StandardTileProps";
import { useHistory } from "react-router-dom";
import { filterPayloadType } from "../../Types/filterPayloadType";
import store from "../../Store/store";
import { storeFilter } from "../../Redux/Actions/filterActions";
import { dashboardFillter } from "../../helpers/dashboardFillterFormatter";
import {
  initialValueOfSearchFamilyGoupForDashboard,
  initialValueOfSearchProductForDailyUpdatesDashboard,
  initialValueOfSearchProductForMissingAttributesDashboard,
} from "../../Models/DashboardModel";
import * as CONSTANT from "../../Constants/index";
import { UI_CONSTANTS } from "../../Constants/constants";
import { ConvertToNumberWithUnit } from "../../helpers/numberHelper";

export const StandardTile: React.FC<StandardTileProps> = ({
  title,
  subtitle,
  value,
  bodyText,
  queryName,
  buttonText,
  isLoading,
}) => {
  const history = useHistory();

  const onClick = (queryName: string) => {
    let payload: filterPayloadType = {
      data: "",
      isDirectQuery: true,
      codeScreen: UI_CONSTANTS.DASHBOARD,
      parentName: "",
      selectedMenu: "",
      createPopupName: undefined,
      deletePopupName: undefined,
      description: undefined,
      nestedSearchId: undefined,
      previousParentName: undefined,
      previousQueryData: undefined,
      searchId: undefined,
      searchPageReset: undefined,
    };
    let dashboardFillterObject: any;

    switch (queryName) {
      case CONSTANT.DashboardFilterContants.FamilyGroupAll:
        payload.data = "";
        payload.isDirectQuery = true;
        payload.parentName =
          CONSTANT.DashboardFilterContants.FamilyGroupParentName;
        payload.selectedMenu =
          CONSTANT.DashboardFilterContants.FamilyGroupSelectedMenu;
        payload.createPopupName = undefined;
        payload.deletePopupName = undefined;

        store.dispatch(storeFilter(payload));
        history.push(CONSTANT.DashboardFilterContants.FamilyGroupPath, {
          HeaderName: CONSTANT.DashboardFilterContants.FamilyGroupHeaderName,
        });
        break;
      case CONSTANT.DashboardFilterContants.FamilyGroupFiltered:
        let familyGroupFilteredObject = {
          FamilyGroup: null,
        };
        dashboardFillterObject = dashboardFillter(
          familyGroupFilteredObject,
          initialValueOfSearchFamilyGoupForDashboard,
          CONSTANT.DashBoardQueryType.FamilyGroupNotAssinged
        );
        payload.data = dashboardFillterObject;
        payload.isDirectQuery = true;
        payload.parentName =
          CONSTANT.DashboardFilterContants.FamilyGroupParentName;
        payload.selectedMenu =
          CONSTANT.DashboardFilterContants.FamilyGroupSelectedMenu;
        payload.createPopupName = undefined;
        payload.deletePopupName = undefined;

        store.dispatch(storeFilter(payload));
        history.push(CONSTANT.DashboardFilterContants.FamilyGroupPath, {
          HeaderName: CONSTANT.DashboardFilterContants.FamilyGroupHeaderName,
        });
        break;
      case CONSTANT.DashboardFilterContants.ProductDailyUpdate:
        let productDailyUpdateObject = {
          UpdatedDate: null,
        };
        dashboardFillterObject = dashboardFillter(
          productDailyUpdateObject,
          initialValueOfSearchProductForDailyUpdatesDashboard,
          CONSTANT.DashBoardQueryType.ProductUpdatedToday
        );
        payload.data = dashboardFillterObject;
        payload.isDirectQuery = true;
        payload.parentName = CONSTANT.DashboardFilterContants.ProductParentName;
        payload.selectedMenu =
          CONSTANT.DashboardFilterContants.ProductSelectedMenu;
        payload.createPopupName = undefined;
        payload.deletePopupName = undefined;

        store.dispatch(storeFilter(payload));
        history.push(CONSTANT.DashboardFilterContants.ProductPath, {
          HeaderName: CONSTANT.DashboardFilterContants.ProductHeaderName,
        });
        break;
      case CONSTANT.DashboardFilterContants.ProductFiltered:
        let productFilteredObject = {
          NewLine: null,
        };
        dashboardFillterObject = dashboardFillter(
          productFilteredObject,
          initialValueOfSearchProductForMissingAttributesDashboard,
          CONSTANT.DashBoardQueryType.NewLineTrue
        );
        payload.data = dashboardFillterObject;
        payload.isDirectQuery = true;
        payload.parentName = CONSTANT.DashboardFilterContants.ProductParentName;
        payload.selectedMenu =
          CONSTANT.DashboardFilterContants.ProductSelectedMenu;
        payload.createPopupName = undefined;
        payload.deletePopupName = undefined;

        store.dispatch(storeFilter(payload));
        history.push(CONSTANT.DashboardFilterContants.ProductPath, {
          HeaderName: CONSTANT.DashboardFilterContants.ProductHeaderName,
        });
        break;

      default:
        break;
    }
  };
  return (
    <div className="home__card-container">
      <p className="home__card-title ln-u-color-orange">{title}</p>

      <p className="home__card-subtitle ln-u-color-grey ln-u-font-family-base">
        {subtitle}
      </p>
      <Heading className="home__card-value ln-u-color-orange">
        {isLoading ? (
          <ProgressSpinner
            size="icon"
            className="ln-u-push-right-sm"
            data-testid="loading-spinner"
          />
        ) : (
          <span title={value?.toString()}>
            {ConvertToNumberWithUnit(value)}
          </span>
        )}
      </Heading>

      <Label className="home__card-body">{bodyText}</Label>

      <FilledButton
        className="home__card-button"
        onClick={() => onClick(queryName)}
      >
        {buttonText}
      </FilledButton>
    </div>
  );
};
